import React from "react";
import TextField from "@mui/material/TextField";
import SingingContract from "../../assests/SingingContract.svg";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import "./CreateUserDetails.css";

export const CreateusersDetails = (props) => {
  return (
    <div className="create-user-details-container">
      <div className="create-user-details-form">
        <Box component="form" noValidate autoComplete="off">
          <TextField
            className="create-user-input"
            fullWidth
            label="Full Name"
            name="name"
            onChange={(e) => props.handleUserName(e)}
            placeholder="Example: Ram Singh"
            autoComplete="off"
          />

          <FormControl fullWidth className="create-user-select">
            <InputLabel>Role</InputLabel>
            <Select label="Role">
              {props.roleList.map((el, index) => (
                <MenuItem
                  key={index}
                  value={index}
                  onClick={(e) => props.handleUserRole(e, el.id)}
                >
                  {el.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          
          <TextField
            className="create-user-input"
            fullWidth
            label="Email ID"
            name="email"
            onChange={(e) => props.handleUserEmail(e)}
            placeholder="Example: DaalChini@gmail.com"
            autoComplete="off"
          />
          
          <TextField
            className="create-user-input"
            fullWidth
            label="Mobile Number"
            name="mobile"
            inputProps={{ maxLength: 10 }}
            onChange={(e) => props.handleUserMobile(e)}
            autoComplete="off"
            placeholder="Example: 9012323134"
          />
          
          <TextField
            className="create-user-input"
            onChange={(e) => props.handleUserPassword(e)}
            name="password"
            fullWidth
            label="Password"
            placeholder="Password"
            type="password"
            autoComplete="off"
          />
        </Box>
      </div>
      
      <div className="create-user-details-image">
        <img src={SingingContract} alt="User Illustration" />
      </div>
    </div>
  );
};